import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  settings: {},
  defaultCurrencyCode: undefined,
  getInstituteSettings: action(function (component) {
    SessionStore.startLoading('Loading…', 'InstitutionSettings');

    api.get(`/installs/${SessionStore.userData.installSid}/settings`)
      .then(response => {
        obx.settings = response.data;

        // API returns empty hide permitted items array as [""] for some reason
        // so loop through array and remove any empty strings
        obx.settings.hidePermittedItemFields.forEach((field, i) => {
          if(!field) {
            obx.settings.hidePermittedItemFields.splice(i, 1);
          }
        });

        if(component) {
          component.setState({
            settings: obx.settings
          });
        }

        SessionStore.finishLoading('InstitutionSettings');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  putInstituteSettings: action(function (data, component, func) {
    SessionStore.startLoading('Loading…', 'PutInstitutionSettings');

    if(data.hidePermittedItemFields[0] === '') {
      data.hidePermittedItemFields = [];
    }

    api.put(`/installs/${SessionStore.userData.installSid}/settings`, data)
      .then(response => {
        obx.settings = response.data;
        component.setState({
          settings: obx.settings
        });
        SessionStore.finishLoading('PutInstitutionSettings');
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  userSettings: {},
  // Get user settings
  getUserSettings: action(function(component, mode=""){
    SessionStore.startLoading('Loading…', 'GetUserSettings');

    api.get(`/installs/${SessionStore.userData.installSid}/users/${SessionStore.userData.userSid}/profile`)
      .then(response => {
        SessionStore.finishLoading('GetUserSettings');
        obx.userSettings = response.data;

        let ie = false;

        if(document.querySelector('html').className.indexOf('ie-true') > -1) {
          ie = true;
        }
        
        // wrapping in a try/catch to avoid any potential issues getting the browser timezone...
        try{
          if(mode === "enroll") { 
            const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const match = SessionStore.timezoneList.find(tz => tz.name === browserTimezone);
            if(match){
              response.data.timeZoneSid = match.sid; 
            }                   
          }       
        }catch(e){
          // NO-OP, this is for safety...
        }       

        if(component && !ie) {
          component.setState({
            homePhone: response.data.homePhone,
            mobilePhone: response.data.mobilePhone,
            currencyCode: response.data.currencyCode,
            timeZoneSid: response.data.timeZoneSid
          });
        } else if(component && ie) {
          component.setState({
            homePhone: response.data.homePhone,
            mobilePhone: response.data.mobilePhone
          });
        }
      })
      .catch(error => {
        obx.throwError(error);
      });
  }),
  // Update user settings data
  updateUserData: action(function(data) {
    let newData = null;

    for(let key in data) {
      if(key) {
        newData = data[key];
        obx.userSettings[key] = newData;
      }
    }
  }),
  // Update user settings API call
  updateUserSettings: action(function(func, dialogMsg, isEnrolling){
    if(isEnrolling) {
      SessionStore.startBackgroundLoading('UpdateUserSettings');
    } else {
      SessionStore.startLoading('Loading…', 'UpdateUserSettings');
    }

    // Remove unnecessary data
    Object.keys(obx.userSettings).map(
      (key) => {
        if(
          key !== 'mobilePhone' &&
          key !== 'homePhone' &&
          key !== 'latitude' &&
          key !== 'longitude' &&
          key !== 'maxTravelDistance' &&
          key !== 'maxTravelDistanceUnits' &&
          key !== 'currencyCode' &&
          key !== 'timeZoneSid' &&
          key !== 'address' &&
          key !== 'preferredEmail'
        ) {
          delete obx.userSettings[key];
        }

        return true;
      }
    );

    if(!obx.userSettings.latitude && SessionStore.userData.role.toLowerCase() === 'learner') {
      SessionStore.finishLoading();
      SessionStore.showDialog(dialogMsg);
      return false;
    }

    if(!obx.userSettings.preferredEmail) {
      obx.userSettings.preferredEmail = SessionStore.profile.email;
    }

    api.put(`/installs/${SessionStore.userData.installSid}/users/${SessionStore.userData.userSid}/profile`, obx.userSettings)
      .then(response => {
        SessionStore.profile = response.data;
        SessionStore.getUserTimezone();

        setTimeout(function(){
          if(isEnrolling) {
            SessionStore.finishBackgroundLoading('UpdateUserSettings');
          } else {
            SessionStore.finishLoading('UpdateUserSettings');
          }

          func();
        });
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get installation integrations
  integrations: [],
  getIntegrations: action(function(callback){
    SessionStore.startLoading('Loading…', 'GetIntegrations');

    obx.integrations = [];

    api.get(`/installs/${SessionStore.userData.installSid}/integrations`)
      .then(response => {
        obx.integrations = response.data.results;

        if(callback) {
          callback(response);
        }

        SessionStore.finishLoading('GetIntegrations');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get single installation integration
  integration: {},
  getIntegration: action(function(integrationSid, callback){
    SessionStore.startLoading('Loading…', 'GetIntegration');

    obx.integration = {};

    api.get(`/installs/${SessionStore.userData.installSid}/integrations/${integrationSid}`)
      .then(response => {
        obx.integration = response.data;

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('GetIntegration');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update integration data
  updateIntegrationData: action(function (data) {
    let newData = null;

    for (let key in data) {
      if (key) {
        newData = data[key];
        obx.integration[key] = newData;
      }
    }
  }),
  // Update integration
  updateIntegration: action(function(integrationSid, callback){
    SessionStore.startLoading('Loading…', 'UpdateIntegration');

    let data = obx.integration;

    if(data && data.systemName.toLowerCase() === 'desire2learn') {
      data.oAuthPostAuthRedirectUri = `${window.location.href}&saved=true`;
    }

    delete data.accessKey;
    delete data.apiUserExternalIdAttribute;
    delete data.apiUserLmsIdAttribute;
    delete data.apiUserSisIdAttribute;
    delete data.applicationInstallSid;
    delete data.createdDate;
    delete data.enabled;
    delete data.failedAuthRedirect;
    delete data.lastModifiedDate;
    delete data.ltiCourseApiIdAttribute;
    delete data.ltiUserExternalIdAttribute;
    delete data.ltiUserLmsIdAttribute;
    delete data.ltiUserSisIdAttribute;
    delete data.name;
    delete data.primaryAccountApiAttribute;
    delete data.primaryAccountLtiAttribute;
    delete data.secret;
    delete data.sid;
    delete data.successfulAuthRedirect;
    delete data.syncEnrollmentsCaseSensitivity;
    delete data.syncEnrollmentsIdentifier;
    delete data.systemModstamp;
    delete data.systemName;

    api.put(`/installs/${SessionStore.userData.installSid}/integrations/${integrationSid}`, data)
      .then(response => {
        obx.integration = response.data;

        SessionStore.finishLoading('UpdateIntegration');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get custom lti roles
  customRoles: [],
  getCustomRoles: action(function(integrationSid, component){
    SessionStore.startLoading('Loading…', 'GetCustomRoles');

    obx.customRoles = [];

    api.get(`/installs/${SessionStore.userData.installSid}/integrations/${integrationSid}/roles`)
      .then(response => {
        obx.customRoles = response.data.results;

        component.setState({
          roles: response.data.results
        });

        SessionStore.finishLoading('GetCustomRoles');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  updateCustomRoles: action(function(integrationSid, data, callback){
    SessionStore.startLoading('Loading…', 'UpdateCustomRoles');

    api.put(`/installs/${SessionStore.userData.installSid}/integrations/${integrationSid}/roles`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('UpdateCustomRoles');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update password
  updatePassword: action(function(data, callback){
    SessionStore.startLoading('Loading…', 'UpdatePassword');

    api.put(`/installs/${SessionStore.userData.installSid}/users/${SessionStore.userData.userSid}/password`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('UpdatePassword');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/SettingsStore.js